<template>
  <div class="collapsible-notes-field">
    <button
      type="button"
      class="collapsible-notes-toggle"
      :aria-expanded="expanded ? 'true' : 'false'"
      @click="expanded = !expanded"
    >
      <AppIcon :name="expanded ? 'bi-chevron-down' : 'bi-chevron-right'" class="collapsible-notes-chevron" />
      <AppIcon :name="icon" class="collapsible-notes-icon" />
      <span class="collapsible-notes-label">{{ label || $t('notes') }}</span>
      <span class="collapsible-notes-optional">({{ $t('optional') }})</span>
    </button>
    <div v-if="expanded" class="collapsible-notes-panel">
      <textarea
        v-bind="$attrs"
        :value="value"
        :rows="rows"
        class="form-control"
        :placeholder="placeholder || $t('add_notes')"
        @input="$emit('input', $event.target.value)"
      ></textarea>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapsibleNotesField',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    rows: {
      type: [Number, String],
      default: 3
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'bi-chat-left-text'
    }
  },
  data() {
    return {
      expanded: false
    }
  }
}
</script>

<style scoped>
.collapsible-notes-field {
  background: #fff;
  border: 1px solid #eaecf0;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
  overflow: hidden;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.collapsible-notes-field:hover {
  border-color: #d0d5dd;
  box-shadow: 0 2px 6px rgba(16, 24, 40, 0.08);
}

.collapsible-notes-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #1d2939;
  display: flex;
  font-size: 0.9rem;
  font-weight: 600;
  gap: 0.75rem;
  min-height: 3rem;
  padding: 0.65rem 1rem;
  text-align: start;
  width: 100%;
}

.collapsible-notes-toggle:hover {
  color: var(--bs-primary);
}

.collapsible-notes-toggle:focus-visible {
  border-radius: 0.7rem;
  box-shadow: inset 0 0 0 2px var(--bs-primary);
  outline: 0;
}

.collapsible-notes-chevron {
  flex: 0 0 auto;
  height: 1.1rem;
  width: 1.1rem;
}

.collapsible-notes-icon {
  flex: 0 0 auto;
  height: 1.25rem;
  width: 1.25rem;
}

.collapsible-notes-label {
  line-height: 1.35;
}

.collapsible-notes-optional {
  color: #98a2b3;
  font-size: 0.85rem;
  font-weight: 400;
  margin-inline-start: -0.35rem;
}

.collapsible-notes-panel {
  border-top: 1px solid #f2f4f7;
  padding: 0.75rem 1rem 1rem;
  padding-inline-start: 3.85rem;
}
</style>
